import React from 'react';
import { scoreToBand, BAND_COLORS } from './types';
export function ScoreRing({ score, size = 120, strokeWidth = 10, label }) {
    const color = BAND_COLORS[scoreToBand(score)];
    const r = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * r;
    const dashOffset = circumference * (1 - Math.min(100, Math.max(0, score)) / 100);
    const cx = size / 2;
    return (<div className="relative inline-flex items-center justify-center flex-col">
            <svg width={size} height={size} style={{ transform: 'rotate(-90deg)' }} aria-hidden="true">
                <circle cx={cx} cy={cx} r={r} fill="none" stroke="#e5e7eb" strokeWidth={strokeWidth}/>
                <circle cx={cx} cy={cx} r={r} fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeDasharray={circumference} strokeDashoffset={dashOffset} style={{ transition: 'stroke-dashoffset 0.6s ease' }}/>
            </svg>
            <div className="absolute inset-0 flex flex-col items-center justify-center">
                <span className="text-2xl font-bold leading-none" style={{ color: '#111827' }}>{score}</span>
                {label !== undefined && (<span className="text-xs text-gray-500 mt-0.5 text-center px-1 leading-tight">{label}</span>)}
            </div>
        </div>);
}
